<template>
  <div
    :class="
      cn(
        'flex flex-col space-y-2 text-center sm:text-left bg-primary-600 text-lg font-semibold px-7 py-4 rounded-t-lg',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '../../utils.js';

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
});
</script>
